import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import ArtpDropdown from '../../../../common/DropDown';
import './stylesheet.scss';

export const capitalize = label => label && `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;

const CountriesDropdown = ({ choose, options, selectedValue }) => {
  if (options.length <= 0) return null;

  return (
    <ArtpDropdown
      right
      className="events-list-filter-bar-country-dropdown"
      title={i18next.t('events.list.filters.countries.title')}
      render={({ close }) => (
        <>
          <div
            className={classNames({ country: true, selected: selectedValue === undefined })}
            onClick={() => {
              choose(undefined);
              close();
            }}
          >
            {i18next.t('events.list.filters.countries.options.all')}
          </div>
          {options.map(({ value, label }) => (
            <div
              className={classNames({ country: true, selected: selectedValue === value })}
              key={value}
              onClick={() => {
                choose(value);
                close();
              }}
            >
              {capitalize(label)}
            </div>
          ))}
        </>
      )}
    />
  );
};

export default CountriesDropdown;
